module.exports = __webpack_public_path__ + "img/img-mob.533fd0bc.png";